var map = {
	"./brand.js": "./src/router/modules/brand.js",
	"./branding.js": "./src/router/modules/branding.js",
	"./car-colores.js": "./src/router/modules/car-colores.js",
	"./clients.js": "./src/router/modules/clients.js",
	"./comission.js": "./src/router/modules/comission.js",
	"./connected-branding.js": "./src/router/modules/connected-branding.js",
	"./contract-templates.js": "./src/router/modules/contract-templates.js",
	"./dashboards.js": "./src/router/modules/dashboards.js",
	"./employees.js": "./src/router/modules/employees.js",
	"./home.js": "./src/router/modules/home.js",
	"./info-news.js": "./src/router/modules/info-news.js",
	"./limit-phone.js": "./src/router/modules/limit-phone.js",
	"./logs.js": "./src/router/modules/logs.js",
	"./messages.js": "./src/router/modules/messages.js",
	"./phoneNumber.js": "./src/router/modules/phoneNumber.js",
	"./photo-report.js": "./src/router/modules/photo-report.js",
	"./private-rent-app.js": "./src/router/modules/private-rent-app.js",
	"./rejection-reasons.js": "./src/router/modules/rejection-reasons.js",
	"./rent-application.js": "./src/router/modules/rent-application.js",
	"./rent-car.js": "./src/router/modules/rent-car.js",
	"./role.js": "./src/router/modules/role.js",
	"./security.js": "./src/router/modules/security.js",
	"./taxi-depot.js": "./src/router/modules/taxi-depot.js",
	"./transaction.js": "./src/router/modules/transaction.js",
	"./workCompletionCertificate.js": "./src/router/modules/workCompletionCertificate.js",
	"./сities.js": "./src/router/modules/сities.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/router/modules sync ([a-z_]+)\\.js$i";